module.exports = __webpack_public_path__ + "img/cloud-snowing-02.30dd0622.svg";